var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_77_826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V16H16V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_77_826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9152 8.2679V12.9879C11.9156 13.191 11.876 13.3922 11.7986 13.58C11.7212 13.7678 11.6076 13.9385 11.4642 14.0823C11.3208 14.2261 11.1505 14.3403 10.9629 14.4183C10.7754 14.4963 10.5743 14.5365 10.3712 14.5367H2.77119C2.36127 14.5367 1.96814 14.3739 1.67828 14.084C1.38843 13.7941 1.22559 13.401 1.22559 12.9911V5.3911C1.22622 4.9816 1.38934 4.58908 1.67913 4.29975C1.96892 4.01041 2.36168 3.8479 2.77119 3.8479H8.46719",
    stroke: "#948B9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78081 9.85361L6.58081 10.1088C6.51785 10.128 6.45086 10.1298 6.38698 10.1139C6.32311 10.098 6.26476 10.065 6.21818 10.0185C6.17159 9.97198 6.13852 9.91369 6.1225 9.84985C6.10647 9.786 6.1081 9.719 6.12721 9.65601L6.38241 8.45601C6.49546 8.0817 6.69939 7.74118 6.97601 7.46481L12.7672 1.67361C12.8341 1.60673 12.9135 1.55367 13.0008 1.51748C13.0882 1.48128 13.1818 1.46265 13.2764 1.46265C13.371 1.46265 13.4646 1.48128 13.552 1.51748C13.6394 1.55367 13.7187 1.60673 13.7856 1.67361L14.5624 2.45041C14.6293 2.51727 14.6823 2.59666 14.7185 2.68403C14.7547 2.7714 14.7734 2.86504 14.7734 2.95961C14.7734 3.05418 14.7547 3.14783 14.7185 3.2352C14.6823 3.32257 14.6293 3.40195 14.5624 3.46881L8.77121 9.26001C8.49501 9.53644 8.1548 9.74035 7.78081 9.85361Z",
    stroke: "#948B9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9288 2.51196L13.724 4.30716",
    stroke: "#948B9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.644d40e612f3677a31ded6bb031f308c.svg";
export { ForwardRef as ReactComponent };